import { ubicationsApi } from "./ubicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  Location,
  CreateLocation,
  UpdateLocation,
  LocationPlace,
  CreateLocationPlace,
  UpdateLocationPlace,
} from "./ubications.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";

export const fetchLocations = createAsyncThunk<
  APIResponse<Location[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/fetchLocations',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        ubicationsApi.endpoints.getLocations.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Almacenes',
          details: data.details
        });
    }
  }
);


export const fetchLocationById = createAsyncThunk<APIResponse<Location>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/fetchLocationById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        ubicationsApi.endpoints.getLocationById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Almacén por ID',
        details: data.details
      });
    }
  }
);


export const createLocation = createAsyncThunk<APIResponse<Location>, CreateLocation,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/createLocation',
  async (data: CreateLocation, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        ubicationsApi.endpoints.createLocation.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Almacén',
        details: data.details
      });
    }
  }
);



export const updateLocation = createAsyncThunk<
  APIResponse<Location>,
   { id: number; changes: UpdateLocation }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/updateLocation',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        ubicationsApi.endpoints.updateLocation.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Almacén',
        details: data.details
      });
    }
  }
);


export const deleteLocation = createAsyncThunk<
  number,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/deleteLocation',
  async (id , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        ubicationsApi.endpoints.deleteLocation.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al eliminar Almacén',
        details: data.details
      });
    }
  }
);


export const fetchLocationsPlaces = createAsyncThunk<
  APIResponse<LocationPlace[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/fetchLocationsPlaces',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        ubicationsApi.endpoints.getLocationsPlaces.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Ubicaciones',
          details: data.details
        });
    }
  }
);


export const fetchLocationPlaceById = createAsyncThunk<APIResponse<LocationPlace>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/fetchLocationPlaceById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        ubicationsApi.endpoints.getLocationPlaceById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Ubicación Física por ID',
        details: data.details
      });
    }
  }
);


export const createLocationPlace = createAsyncThunk<APIResponse<LocationPlace>, CreateLocationPlace,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/createLocationPlace',
  async (data: CreateLocationPlace, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        ubicationsApi.endpoints.createLocationPlace.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Ubicación Física',
        details: data.details
      });
    }
  }
);



export const updateLocationPlace = createAsyncThunk<
  APIResponse<LocationPlace>,
   { id: number; changes: UpdateLocationPlace }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/updateLocationPlace',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        ubicationsApi.endpoints.updateLocationPlace.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Ubicación Física',
        details: data.details
      });
    }
  }
);


export const deleteLocationPlace = createAsyncThunk<
  number,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'locations/deleteLocationPlace',
  async (id , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        ubicationsApi.endpoints.deleteLocationPlace.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al eliminar Ubicación Física',
        details: data.details
      });
    }
  }
);